import { Button, InfoPage } from "@shapr3d/frontend-lib";

import useNavigation from "../hooks/navigation";

export const SSOTimeoutErrorPage: React.FC = () => {
  const navigation = useNavigation();

  return (
    <InfoPage
      variant="warning"
      title="Session timed out, please log in again."
      primaryCTA={<Button onClick={() => navigation.goToSignIn()}>Back to log in</Button>}
    />
  );
};
